import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { uiResources } from '@popety-io/ui'

import { de } from '@i18n-locales/de'
import { en } from '@i18n-locales/en'
import { fr } from '@i18n-locales/fr'
import { it } from '@i18n-locales/it'
import { NAMESPACES } from './i18n/namespaces'

/** Hyphenated namespaces kept for existing `useTranslation('land-analysis')` calls. */
const withLegacyNamespaces = (catalogue: Record<string, unknown>) => ({
  ...catalogue,
  'land-analysis': catalogue.landAnalysis,
  'building-analysis': catalogue.buildingAnalysis,
})

const resources = {
  en: { ...withLegacyNamespaces(en), ...uiResources.en },
  fr: { ...withLegacyNamespaces(fr), ...uiResources.fr },
  de: { ...withLegacyNamespaces(de), ...uiResources.de },
  it: { ...withLegacyNamespaces(it), ...uiResources.it },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: resources as any,
    lng: 'en',
    fallbackLng: 'en',
    ns: NAMESPACES,
    defaultNS: 'common',
    nsSeparator: '.',
    keySeparator: '.',
    debug: process.env.NODE_ENV === 'development',
    interpolation: { escapeValue: false },
    saveMissing: true,
    missingKeyHandler: (lngs: any, ns: any, key: any) => {
      if (process.env.NODE_ENV !== 'development') return
      console.warn(
        `Missing translation: ${ns}:${key} for languages: ${lngs.join(', ')}`
      )
    },
    parseMissingKeyHandler: (key: any) => {
      const parts = key.split('.')
      const lastWord = parts[parts.length - 1]

      return lastWord
        .replace(/([A-Z])/g, ' $1')
        .replace(/_/g, ' ')
        .replace(/^./, (str: any) => str.toUpperCase())
    },
  })

export default i18n
